(ns dre.modals.question-answering.views
  (:require
   ["antd" :refer [Spin Row Col]]
   [dre.components.icon :refer [icon]]
   [dre.components.inputs :refer [checkbox input-textarea]]
   [dre.components.form :refer [form form-item]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.question-answering.events :as events]
   [dre.widgets.question-answering.events :as qa-events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :modal-qa-feedback)

(defn content
  []
  (let [data @(rf/subscribe [::events/state])
        reasons (get data :reasons)
        additional-feedback (get data :additional-feedback)]
    [:div
   {:class component-name}
   [form
    {:layout "vertical"}
    [:<>
     [form-item
      {}
      [:div
       [:> Row
        {:gutter [16 16]
         :align "middle"}
        (doall (for [e events/options]
                 ^{:key  (first e)}
                 [:> Col
                  {:span 8}
                  [:button
                   {:class [(if (contains? reasons (first e))
                              (bem/bm :button :brand)
                              (bem/bm :button :solid))
                            (bem/be component-name :option-button)]
                    :on-click #(rf/dispatch [::events/update-reasons (first e)])}
                   [:div
                    {:class (bem/be component-name :option-button-content)}
                    [tr (second e)]]]]))
        ]]]
     [form-item
      {:label [tr "Please provide feedback on how the response can be improved. (Optional)"]}
      [input-textarea {:on-change #(rf/dispatch [::events/update-additional-feedback (-> % .-target .-value)])
                       :value additional-feedback}]]]]]))

(defn view
  []
  (fn []
    (let [data @(rf/subscribe [::events/state])
          reasons (get data :reasons)
          additional-feedback (get data :additional-feedback)]
      [modal-window
       {:title "Help us improve"
        :sub-title "(Provide additional feedback on this answer. Select all that apply.)"
        :content content
        :submit? true
        :submit-text [tr "Submit"]
        :submit-disabled? (when (not (seq reasons))
                            true)
        :on-submit (fn [e]
                     (rf/dispatch [::events/clear])
                     (rf/dispatch [::qa-events/vote false {:issues (into (list) reasons) :feedback additional-feedback}]))}])))